const MODULE_NAME = "COUNTRIES";
const FETCH_COUNTRIES_STARTED = MODULE_NAME + 'FETCH_STARTED';
const FETCH_COUNTRIES_COMPLETED = MODULE_NAME + 'FETCH_COMPLETED';

export {
  FETCH_COUNTRIES_STARTED,
  FETCH_COUNTRIES_COMPLETED
};
